require("./../app");

import {BREAKPOINTS} from "../support/constants";
import store from "../store/store";
import Vue from "vue";

/** Universal Components*/
Vue.component("add-to-cart-button", require("../components/Universal/AddToCartButton.vue").default);
Vue.component("breadcrumb", require("../components/Universal/Breadcrumb.vue").default);
Vue.component('favorite-button', require('../components/Universal/FavoriteButton.vue').default);
Vue.component("reserved-ribbon", require("./../components/Universal/Ribbon/ReservedRibbon.vue").default);
Vue.component("sold-ribbon", require("./../components/Universal/Ribbon/SoldRibbon.vue").default);

/** Module Components */
Vue.component('the-description-box', require('./../components/Modules/Exhibit/TheDescriptionBox.vue').default)
Vue.component("the-exhibit-grid", require("./../components/Modules/Exhibit/TheExhibitGrid").default);
Vue.component('the-other-events', require('./../components/Modules/Exhibit/TheOtherEvents.vue').default);

new Vue({
  el: "#app",
  mq: BREAKPOINTS,
  store: store,
});
